module.exports = __webpack_public_path__ + "static/media/fota_waiting.2bac3762.png";